import { createPortal } from "react-dom";
import { WithChildren } from "../DataTypes/WithChildren";

export const Portal = ({ children }: WithChildren) => {
	const portal = document.getElementById("portal-root") as HTMLElement;
	if(!portal) return <></>
	return createPortal(children, portal);
};
